import ReviewStars from "@/components/sections/review/ReviewStars";
import ReviewAction from "@/components/sections/review/ReviewAction";

const BLOB_SIZE_LG = 360;
const BLOB_SIZE_SM = 240;

export default function ReviewCard({ t }) {
  return (
    <div
      className="relative overflow-hidden rounded-3xl bg-[var(--primary)] text-white p-8 sm:p-14"
      data-testid="review-card"
    >
      <div
        className="hero-blob"
        style={{ width: BLOB_SIZE_LG, height: BLOB_SIZE_LG, background: "#1995AD", top: -120, right: -120, opacity: 0.45 }}
      />
      <div
        className="hero-blob"
        style={{ width: BLOB_SIZE_SM, height: BLOB_SIZE_SM, background: "#E05A33", bottom: -90, left: -60, opacity: 0.35 }}
      />

      <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <span className="label-eyebrow text-white/70">{t.review.label}</span>
          <ReviewStars />
          <h2 className="font-heading text-3xl sm:text-5xl leading-tight mb-4">
            {t.review.title}
          </h2>
          <p className="text-white/80 text-lg max-w-xl leading-relaxed">
            {t.review.body}
          </p>
        </div>
        <ReviewAction ctaLabel={t.review.cta} subnote={t.review.subnote} />
      </div>
    </div>
  );
}
